<template>
<div class="travel2023">
    <div class="top-ornament">
        
    </div>
    <div class="cont">
        <p class="only-pc">夏天和什么最配？约克论坛邀您一起记录夏日美好，发帖参与话题#多伦多的美好夏天#，与广大网友一起你心中和夏天最配的美食和好玩的地方吧，还有机会获得惊喜哦~  </p>
        <div class="main-title">活动主题</div>
        <div class="text main-space">
            
            带话题 <strong>#多伦多的美好夏天#</strong>，发布帖子即成功参与活动。
        </div>
        <div class="main-title">参与方式</div>
        <div class="ps-text">发帖可以参考以下两个方向：</div>
        <div class="text">
           <strong>01 夏日美食：</strong>
           是喷香四溢的烧烤、是冰镇西瓜中间那一口，是酸辣鲜爽的凉拌菜…你最喜欢夏日消暑美食是什么？
        </div>
        <div class="text mrg-space">
            <strong>02 夏日好去处：</strong>是刺激好玩的水上乐园，是悠闲的沙滩徜徉，是公园的静谧一角…哪里是你最喜欢的夏日好去处？
        </div>
        <div class="main-title only-pc">活动奖励/评选方式</div>
        <div class="text only-pc"><strong>优质作品奖 10名</strong></div>
        <div class="text only-pc">
            10名，每人奖励10加币礼品卡（或等值微信红包）。 
        </div>
        <div class="text only-pc">
            结合帖子内容图文质量以及帖子的浏览量、回复量、点赞量等，在精选作品中选择10名获奖者。 
        </div>
        <div class="text only-pc"><strong>精选作品奖 不限量</strong></div>
        <div class="text only-pc">
            从每日参与者中精选，可获得5-10元微信红包。
        </div>
    </div>
    <a href="https://forum.yorkbbs.ca/detail/3e9499a5-45c6-4461-9052-a0b20585d99a?topic=chat" class="paly-detail" target="_blank">活动详情&gt;</a>
</div>
</template>
<script>
export default {
    name:'TravelIntroduction',
    
}
</script>
<style lang="less" scoped>
.travel2023{
    position: relative; z-index: 2;
    &::before{
        position: absolute; left: 0; top:22px; right: 8px ; bottom: 0; content: ''; z-index: -2; background: #fff3d8;  border-radius: 10px;
    }
    &:after{
        position: absolute; left: 8px; top: 14px; right: 0; bottom: 8px; content:''; background: url(https://media2.imgyb.xyz/media/v1/image/98e169347f4e6f35d26e1c8e79c36ec3.jpeg) repeat left top; z-index: -1; border-radius: 10px;
    }
    .top-ornament{
        position: absolute; z-index: 2; left: 50px; right: 50px; top: 0; height: 33px; background: url(https://media6.imgyb.xyz/media/v1/image/d274aba79fc6d3a9c7d18e5253b60d34.png) repeat-x;
    }
    .cont{
        padding: 58px 50px 50px;
        p{
            font-size: 18px; line-height: 30px; color: #333; margin-bottom: 20px;
        }
        .main-title{font-size: 16px; line-height: 24px; color: #F25029; font-weight: bold; margin-bottom: 5px;}
        .text{font-size: 16px; line-height: 26px;}
        .ps-text{font-size: 14px; line-height: 20px; color: #333; margin-bottom: 5px;}
        .main-space{margin-bottom: 20px;}
        .mrg-space{margin-bottom: 12px;}
    }
    .paly-detail{
        position: absolute; z-index: 2; right: 50px; bottom: 40px; color: #F25029; font-size: 16px; line-height: 24px;
    }
}
@media screen and (max-width:768px){
    .travel2023{
        .top-ornament{background-size: 19px 16px; left: 25px; right: 25px;}
        &:before{top: 14px;}
        &:after{top: 6px;}
        .cont{
            padding: 28px 25px 30px;
        }
        .paly-detail{bottom: 20px;}
    }
}
</style>